import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const NotificationsHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Notifications
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Configure and manage your notification preferences to stay informed about important
            updates in your hiring process. Customize how and when you receive notifications.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Notification Types
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Set up notifications for various events including new applications, interview updates,
            candidate responses, and system alerts. Choose which events trigger notifications.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Delivery Methods
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Receive notifications through multiple channels including email, in-app alerts,
            and mobile push notifications. Configure different delivery methods for different events.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Team Notifications
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Manage team-wide notification settings. Ensure the right team members receive
            relevant updates based on their roles and responsibilities.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Notification Preferences
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Customize your notification preferences to avoid information overload. Set quiet hours,
            configure digest emails, and prioritize important notifications.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/automation/notifications"
              color="primary"
              variant="contained"
            >
              Configure Notifications
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default NotificationsHelp; 